var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.7564 9C21.254 9 9.5 20.754 9.5 35.2536C9.49964 38.7018 10.1785 42.1162 11.4979 45.3019C12.8173 48.4877 14.7513 51.3823 17.1895 53.8205C19.6277 56.2587 22.5223 58.1927 25.7081 59.5121C28.8938 60.8315 32.3082 61.5104 35.7564 61.51C50.2533 61.51 62.01 49.756 62.01 35.2536C62.01 20.754 50.2533 9 35.7564 9ZM38.2067 18.4787C40.7664 18.4787 41.5185 19.9636 41.5185 21.6619C41.5185 23.7813 39.8229 25.7422 36.9268 25.7422C34.5039 25.7422 33.3498 24.5252 33.4209 22.5097C33.4209 20.8114 34.8402 18.4787 38.2067 18.4787ZM31.6488 50.9785C29.8985 50.9785 28.6214 49.9146 29.8438 45.2519L31.8484 36.9793C32.1957 35.6556 32.2531 35.1251 31.8484 35.1251C31.3261 35.1251 29.0535 36.0385 27.7135 36.941L26.8411 35.5107C31.0936 31.9583 35.9834 29.8744 38.0754 29.8744C39.8257 29.8744 40.1156 31.9418 39.2432 35.1251L36.946 43.8216C36.5385 45.3585 36.7135 45.8891 37.121 45.8891C37.6461 45.8891 39.3635 45.2546 41.0536 43.9228L42.0436 45.2519C37.9059 49.3868 33.3963 50.9785 31.6488 50.9785Z",
    fill: "#606060"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.e3e3432d26e08730f69fef9ca904d1ca.svg";
export { ForwardRef as ReactComponent };